module.exports = __webpack_public_path__ + "static/media/image9.76bb0d84.jpg";